import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Button,
    Select,
    MenuItem,
    Divider,
    Paper,
    usePagination,
    TextField,
    InputAdornment,
    FormControlLabel,
    Collapse,
    Checkbox,
    Autocomplete,
    Typography
} from "@mui/material";
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import Search from "@mui/icons-material/Search";
import SimpleDialog from "../../../../components/SimpleDialog";
import { ReactComponent as HistoryLF } from "../../../../assets/icons/historyLF.svg";
import { ReactComponent as Preview } from "../../../../assets/icons/preview.svg";
import { ReactComponent as LaunchFormIcon } from "../../../../assets/icons/launchForm.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as IconXsearch } from "../../../../assets/icons/iconXsearch.svg";
import { ReactComponent as CloseIconLF } from "../../../../assets/icons/closeIconLF.svg";
import launchFormService from "../../../../services/launchForm.service";
import * as Util from "../../../../services/global.service";
import cssVariables from "../../../../theme/cssVariables";
import DialogLaunchForm from "./DialogLaunchForm";
import { styled } from "@mui/styles";
import { debounce, find } from 'lodash';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { width } from "@mui/system";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    flexPaper: {
        flex: 1,
        minWidth: 350,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        borderRadius: "10px !important        "
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap',
        marginTop: "30px"
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));

const LaunchForm = () => {
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [open, setOpen] = React.useState(false);
    let [type, setType] = React.useState("");
    let [list, setList] = React.useState([]);
    const navigate = useNavigate();
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [targetGroups, setTargetGroups] = React.useState([]);
    const [dataFilter, setDataFilter] = React.useState({});
    const [selected, setSelected] = React.useState([]);
    const [search, setSearchValue] = React.useState("");
    const [oldDataFilter, setOldDataFilter] = React.useState({});
    const [showLoading, setShowLoading] = React.useState(false);
    const [openLaunchForm, setOpenLaunchForm] = React.useState(false);
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [focusSearch, openFocusSearch] = React.useState(false);
    const [selectSearch, setSelectSearch] = React.useState([]);
    const [cycle, setCycle] = React.useState({});

    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        descriptionEN: yup.string().max(1000).required(t('admin.inputForm.msgError.nameTH')),
        competencyType: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
        ratingScaleMaster: yup.string().max(255).required(t('admin.inputForm.msgError.plessSelect')),
    });
    const formik = useFormik({
        initialValues: {
            cycle: "",
            journey_id: "",
            target_type: "",
            target_group: "",
            target_group_show: {},
            word: "",
            employees: [],
            except_probation: false,
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        },
    });

    useEffect(() => {
        launchFormService.getFilter().then((rs) => {
            setDataFilter(Util.formatData(rs?.data, {}));
        }).catch((err) => {

        })
    }, []);

    const handleClose = (event) => {
        let dataSet = selected.map(a => a?.id)
        setSelectSearch([])
        openFocusSearch(false)
        setMainItems(selected)
        setItems(selected)
        formik.setFieldValue("employees", dataSet)
        if (Util.formatData(document.getElementById('searchEmployee'), false) !== false) {
            document.getElementById('searchEmployee').value = ""
        }
    };

    const handleFocus = () => {
        openFocusSearch(true)

    };

    let setValFilter = (field, data) => {
        if (field === "journey_id") {
            let dt = dataFilter.journeys.find((rs) => rs?.id === data)
            setTargetGroups(Util.formatData(dt?.target_groups, []))
            if (Util.formatData(formik.values.target_group,) !== false) {
                formik.setFieldValue("target_group", "")
                formik.setFieldValue("target_group_show", {})
            }
        }
        if (field === "target_type") {
            setSelected([])
        }
        if (field === "cycle") {
            formik.setFieldValue("journey_id", "")
            formik.setFieldValue("except_probation", false)

            let cycleSelected = find(dataFilter.cycles, { id: data })
            setCycle(cycleSelected)

        }
        if (field === "target_group") {
            formik.setFieldValue("target_group", data.id)
            formik.setFieldValue("target_group_show", data)
        } else {
            formik.setFieldValue(field, data)
        }
    }

    let checkPreview = () => {
        if (Util.formatData(formik.values.journey_id, false) !== false && Util.formatData(formik.values.target_type, false) !== false && Util.formatData(formik.values.target_group, false) !== false) {
            return false
        }
        if (Util.formatData(formik.values.target_type, "") === "specify_employee") {
            return false
        }
        return true
    }

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return items
            .slice(firstPageIndex, lastPageIndex);
    }, [items, currentPage, perPage]);

    let closeLaunchForm = () => {
        setOpenLaunchForm(false)
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };

    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };

    const handleTotalPage = () => {
        const List = items
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };

    useEffect(() => {
        handleTotalPage();
    }, [items, perPage]);

    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            currentData.sort(function (b, a) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            currentData.sort(function (a, b) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }

    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    useEffect(() => {
        dataSerachs(mainItems)
    }, [search]);

    useEffect(() => {
        setSelectSearch([])
        openFocusSearch(false)
        formik.setFieldValue("target_type", "")
        formik.setFieldValue("target_group", "")
        formik.setFieldValue("word", "")
        formik.setFieldValue("employees", [])
        setMainItems([])
        setItems([])
    }, [formik.values.journey_id]);

    const dataSerachs = async (data, type) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'organization' || key === "position" || key === "position_type") {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'name') {
                        let checkName = false;
                        if (rs[key].en !== undefined && rs[key].en.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        if (rs[key].th !== undefined && rs[key].th.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                            checkName = true;
                        }
                        return checkName;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        await setItems(result);
    };

    // const [query, setQuery] = React.useState("");

    const changeHandler = event => {
        // setQuery(event.target.value);
        if (event.target.value.length > 2) {
            getDataFilter(event.target.value,)
        }
    };
    const debouncedChangeHandler = useCallback(
        debounce(changeHandler, 500), console.log()
        , []);

    let getDataFilter = (text) => {
        if (Util.formatData(formik.values.target_type, "") === "target_group") {
            setShowLoading(true)
            let data = {
                journey_id: formik.values.journey_id,
                target_type: formik.values.target_type,
                target_group: formik.values.target_group,
                except_probation: formik.values.except_probation,
            }
            launchFormService.getListEmployee(data).then((rs) => {
                setOldDataFilter(data)
                setMainItems(Util.formatData(rs?.data?.employees, []))
                dataSerachs(Util.formatData(rs?.data?.employees, []))
                setShowLoading(false)
                formik.setFieldValue("employees", [])
                setSelectSearch([])
            }).catch((error) => {
                setShowLoading(false)
            })
        }
        if (Util.formatData(formik.values.target_type, "") === "specify_employee") {
            let data = {
                journey_id: formik.values.journey_id,
                target_type: formik.values.target_type,
                word: text
            }
            launchFormService.getListEmployee(data).then((rs) => {
                setOldDataFilter(data)
                setSelectSearch(Util.formatData(rs?.data?.employees, []))
            }).catch((error) => {

            })
        }
    }

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };

    let handleDirect = async () => {
        formik.setFieldValue("employees", [])
        setSelectSearch([])
        setSelected([])
        setMainItems([])
        setItems([])
        if (oldDataFilter?.target_type === "target_group") {
            getDataFilter()
        }
        openSuccessAddDialog(false)
    }

    const handleClick = (data) => {
        const selectedIndex = selected.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const handleClickAll = () => {
        let newSelected = [...selected];
        if (checkAll() === true) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = newSelected.filter((rs) => rs?.id !== selectSearch[index]?.id)
                newSelected = dtFilter
            }
            setSelected(newSelected);
        } else {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = newSelected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length <= 0) {
                    newSelected.push(selectSearch[index])
                }
            }
            setSelected(newSelected);
        }
    };

    let checkSelect = (data) => {
        let check = false
        let checkFilterData = selected.filter((rs) => rs?.id === data)
        if (checkFilterData.length > 0) {
            check = true
        }
        return check
    }

    let checkAll = () => {
        let selectAll = true
        if (selectSearch.length > 0) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = selected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length <= 0) {
                    selectAll = false
                }
            }
        } else {
            selectAll = false
        }
        return selectAll
    }

    let checkIndeterminate = () => {
        let selectTrue = []
        let selectFalse = []
        if (selectSearch.length > 0) {
            for (let index = 0; index <= selectSearch.length - 1; index++) {
                let dtFilter = selected.filter((rs) => rs?.id === selectSearch[index]?.id)
                if (dtFilter.length > 0) {
                    selectTrue.push("1")
                } else {
                    selectFalse.push("1")
                }
            }
            if (selectTrue.length > 0 && selectFalse.length > 0) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const clearAll = () => {
        setSelected([])
        formik.setFieldValue("employees", [])
        setMainItems([])
        setItems([])
    }
    let clearOne = (data) => {
        const selectedIndex = selected.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        setMainItems(newSelected)
        setItems(newSelected)
        let dataSet = newSelected.map(a => a?.id)
        formik.setFieldValue("employees", dataSet)
    }
    return (
        <Box style={{ maxHeight: "100%", overflowY: "auto" }}>
            <Helmet>
                <title>Launch Form | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.end} >
                                Launch Form
                            </span>
                        </Typography>
                    </Grid>
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                Launch Form
                            </Typography>
                            <Button onClick={() => { clickLink("/admin/launch-form/history") }} sx={{ display: "flex", height: "45px", textTransform: "none" }} variant="dashed-solid" >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <HistoryLF /><Typography ml="8px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#404349">View History</Typography>
                                </Box>
                            </Button>
                        </Box>
                        <Box sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }} p="20px 40px 25px" mt="30px">
                            <Box sx={{ margin: "0 -40px", display: "flex", flexFlow: "row wrap" }}>
                                <Box pb="20px" sx={{ width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Cycle <span style={{ color: "#CC6058" }}>*</span></Typography>
                                    <Select
                                        variant="outlined"
                                        defaultValue=""
                                        displayEmpty
                                        size="small"
                                        fullWidth
                                        className="white-bg"
                                        value={formik.values.cycle}
                                        classes={{ root: classes.select }}
                                        MenuProps={{ autoFocus: false }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select Cycle</Typography>
                                        </MenuItem>
                                        {Util.formatData(dataFilter?.cycles, []).length > 0 ?
                                            dataFilter?.cycles.map((item, idx) => {
                                                return (
                                                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("cycle", item.id)}>
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.code} {Util.formatData(item?.code, false) !== false && Util.formatData(item?.name, false) !== false ? "-" : ""} {item?.name}</span>
                                                    </MenuItem>
                                                )
                                            })
                                            :
                                            <MenuItem value="">
                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                            </MenuItem>
                                        }
                                    </Select>
                                </Box>
                                <Box pb="20px" sx={{ ".MuiSvgIcon-root .Mui-disabled": { background: "transparent" }, width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Evaluation Journey <span style={{ color: "#CC6058" }}>*</span></Typography>
                                    <Select
                                        variant="outlined"
                                        defaultValue=""
                                        displayEmpty
                                        size="small"
                                        disabled={Util.formatData(formik?.values?.cycle, false) === false}
                                        fullWidth
                                        className="white-bg"
                                        value={formik.values.journey_id}
                                        classes={{ root: classes.select }}
                                        MenuProps={{ autoFocus: false }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select Evaluation Journey</Typography>
                                        </MenuItem>
                                        {Util.formatData(dataFilter?.journeys, []).length > 0 ?
                                            dataFilter?.journeys.map((item, idx) => {
                                                return (
                                                    item?.cycle === formik.values.cycle ?
                                                        <MenuItem value={item.id} key={idx} onClick={e => setValFilter("journey_id", item.id)}>
                                                            <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.code} {Util.formatData(item?.code, false) !== false && Util.formatData(item?.name, false) !== false ? "-" : ""} {item?.name}</span>
                                                        </MenuItem>
                                                        :
                                                        null
                                                )
                                            })
                                            :
                                            <MenuItem value="">
                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                            </MenuItem>
                                        }
                                    </Select>
                                </Box>
                                <Box pb="20px" sx={{ ".MuiSvgIcon-root .Mui-disabled": { background: "transparent" }, width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Target Type <span style={{ color: "#CC6058" }}>*</span></Typography>
                                    <Select
                                        variant="outlined"
                                        defaultValue=""
                                        displayEmpty
                                        size="small"
                                        fullWidth
                                        className="white-bg"
                                        disabled={Util.formatData(formik?.values?.journey_id, false) === false}
                                        value={formik.values.target_type}
                                        classes={{ root: classes.select }}
                                        MenuProps={{ autoFocus: false }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select Target Type</Typography>
                                        </MenuItem>
                                        {Util.formatData(dataFilter?.target_type, []).length > 0 ?
                                            dataFilter?.target_type.map((item, idx) => {
                                                return (
                                                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("target_type", item.id)}>
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                                                    </MenuItem>
                                                )
                                            })
                                            :
                                            <MenuItem value="">
                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                            </MenuItem>
                                        }
                                    </Select>
                                </Box>

                                {(Object.keys(cycle).length > 0 && !cycle?.is_probation) &&
                                    <Box pb="20px" sx={{ width: "calc(50% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                        <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" >{t('admin.label.exceptProbationEmployee')}</Typography>
                                        <FormControlLabel control={<Checkbox onChange={(e) => setValFilter('except_probation', e.target.checked)} />} sx={{ mt: "10px" }} label="" />
                                    </Box>
                                }

                                {formik.values.target_type === "target_group" &&
                                    <Box pb="20px" sx={{ width: "calc(100% - 80px)", ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                        <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Target Group <span style={{ color: "#CC6058" }}>*</span></Typography>
                                        <Autocomplete
                                            id="country-select-demo"
                                            options={targetGroups}
                                            disableClearable
                                            defaultValue=""
                                            displayEmpty
                                            value={formik.values.target_group_show}
                                            getOptionLabel={(option) => Util.formatData(option?.name, "")}
                                            onChange={(event, newValue) => {
                                                setValFilter("target_group", newValue)
                                            }}
                                            MenuProps={{ autoFocus: false }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    sx={{ ".MuiOutlinedInput-root": { pr: "30px !important" } }}
                                                    defaultValue=""
                                                    displayEmpty
                                                    size="small"
                                                    placeholder="Select Target Group"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        // autoComplete: 'new-password', // disable autocomplete and autofill
                                                        sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA",
                                                                fontWeight: "300",
                                                                opacity: "1"
                                                            }
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </Box>
                                }


                                {formik.values.target_type === "specify_employee" &&
                                    <Box pb="20px" sx={{ width: "calc(100% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                        <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Employee <span style={{ color: "#CC6058" }}>*</span></Typography>
                                        <Box sx={{ position: "relative" }}>
                                            <TextField
                                                id="searchEmployee"
                                                fullWidth
                                                placeholder="Search employee"
                                                size="small"
                                                onFocus={e => handleFocus(true)}
                                                sx={{ background: "#fff", "input": { padding: "9px 14px" } }}
                                                className="searchTextField-h40"
                                                autoComplete='off'
                                                onChange={debouncedChangeHandler}
                                            />
                                            <Box sx={{ position: "absolute", width: "100%", zIndex: "9" }}>
                                                <Collapse in={focusSearch}>
                                                    <Box sx={{ width: "100%", background: "#FAFAFA", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)", borderRadius: "11px" }} p="39px 39px 25px">
                                                        <Box sx={{ borderBottom: "1px solid #A0A0A0", display: "flex", width: "100%" }} pb="11px" mb="15px">
                                                            <Checkbox
                                                                onClick={(event) => handleClickAll()}
                                                                sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                                indeterminate={checkIndeterminate()}
                                                                checked={checkAll()}
                                                            />
                                                            {/* 15.77+20.84+22.49+20.49+20.41 */}
                                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.77% - 11.8px)" }} pr="20px">
                                                                <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                    Employee Code
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(20.84% - 11.8px)" }} pr="20px">

                                                                <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                    Name
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                    Position
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                    Organization
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(16.41% - 11.8px)" }} >
                                                                <Typography fontSize={16} width="100%" lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                    Position Type
                                                                </Typography>
                                                                <IconXsearch style={{ cursor: "pointer" }} onClick={handleClose} />
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ maxHeight: "270px", overflowY: "overlay", }} >
                                                            {selectSearch.length > 0 ? selectSearch.map((rs, index) => (
                                                                <Box sx={{ display: "flex", width: "100%" }} pb={index + 1 === selectSearch.length ? "0" : "30px"}>
                                                                    <Checkbox
                                                                        onClick={(event) => handleClick(rs)}
                                                                        sx={{ margin: "0 35px 0 0", padding: "0", alignItems: "center" }}
                                                                        // onChange={e => changeType(data?.serial)} 
                                                                        checked={checkSelect(rs?.id)}
                                                                    />
                                                                    {/* 15.77+20.84+22.49+20.49+20.41 */}
                                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.77% - 11.8px)" }} pr="20px">
                                                                        <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                            {rs?.code}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "calc(20.84% - 11.8px)" }} pr="20px">
                                                                        <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                            {i18n.language === "th-TH" ? Util.formatData(rs?.name?.th, false) !== false ? rs?.name?.th : rs?.name?.en : Util.formatData(rs?.name?.en, false) !== false ? rs?.name?.en : rs?.name?.th}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                        <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                            {rs?.position}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "calc(23.49% - 11.8px)" }} pr="20px">
                                                                        <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                            {rs?.organization}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "calc(16.41% - 11.8px)" }} pr="25px">
                                                                        <Typography fontSize={18} width="100%" lineHeight="26.91px" color="#404349" fontWeight="400" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }}>
                                                                            {rs?.position_type}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            ))
                                                                :
                                                                <Box sx={{ paddingTop: "10px", textAlign: "center" }}>
                                                                    <Nodata />
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                                        No data found
                                                                    </Typography>
                                                                    {/* <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                                Please import the data.
                                                            </Typography> */}
                                                                </Box>
                                                            }
                                                        </Box>
                                                    </Box>
                                                </Collapse>
                                            </Box>
                                        </Box>
                                    </Box>
                                }


                            </Box>
                            {formik.values.target_type !== "specify_employee" ?
                                <Box sx={{ justifyContent: "flex-end", display: "flex", paddingTop: "10px" }}>
                                    <Box sx={{ display: "flex", }}>
                                        <Button color="primary" variant="contained" fullWidth disabled={checkPreview()} onClick={getDataFilter}>
                                            <Preview /> <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Preview</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                                :
                                null}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="30px">
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="45px" >
                                Preview
                            </Typography>
                            {oldDataFilter?.target_type !== "target_group" ?
                                <Box sx={{ display: "flex" }}>
                                    <Button color="primary" variant="contained" onClick={e => setOpenLaunchForm(true)} disabled={Util.formatData(formik.values.journey_id, false) === false || Util.formatData(formik.values.target_type, false) === false || Util.formatData(formik.values.employees, []).length <= 0 || items.length <= 0}>
                                        <LaunchFormIcon /> <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Launch Form</Typography>
                                    </Button>
                                </Box>
                                : null
                            }
                        </Box>
                        {oldDataFilter?.target_type === "target_group" ?
                            <Box>
                                <Typography fontWeight="300" color="#A3A3A3" fontSize={16} lineHeight="23.92px" pt="5px" pb="10px">
                                    Showing {(perPage * (currentPage - 1)) + 1}-{perPage * currentPage} out of {mainItems.length} results
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        fullWidth
                                        placeholder={t('admin.label.search')}
                                        size="small"
                                        sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                        className="searchTextField-h40"
                                        value={search}
                                        onChange={handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <Button color="primary" variant="contained" onClick={e => setOpenLaunchForm(true)} disabled={Util.formatData(formik.values.journey_id, false) === false || Util.formatData(formik.values.target_type, false) === false || Object.keys(oldDataFilter).length <= 0 || items.length <= 0} >
                                        <LaunchFormIcon /> <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Launch Form</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            : null
                        }
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box
                                    px="40px"
                                >
                                    {formik.values.employees.length > 0 ?
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", flexDirection: "row" }}
                                        >
                                            {/* 18.15 32.2 22.2 17.45 10 */}
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(15.15% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.inputForm.code')} */}
                                                    Code
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
                                        </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(28.2% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.employeeName')} */}
                                                    Name
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                        </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(22.2% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('competencyMapping.totalCompetency')} */}
                                                    Position
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position", false)} />
                                        </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(22% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.updatedBy')} */}
                                                    Organization
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("organization", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("organization", false)} />
                                        </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "calc(12.45% - 15px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.createdBy')} */}
                                                    Position Type
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                            <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position_type", true)} />
                                            <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position_type", false)} />
                                        </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "75px" }} pl="5px">
                                                <Typography onClick={clearAll} fontSize={16} lineHeight="23.96px" color="#AAAAAA" textAlign='center' fontWeight="400" sx={{ cursor: "pointer", letterSpacing: "-0.02em", textDecorationLine: "underline", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", }}>
                                                    Clear All
                                                </Typography>
                                            </Box>
                                        </Box>
                                        :
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", flexDirection: "row" }}
                                        >
                                            {/* 18.15 32.2 22.2 17.45 10 */}
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "15.15%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.inputForm.code')} */}
                                                    Code
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("code", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("code", false)} />
                                            </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "28.2%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.employeeName')} */}
                                                    Name
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                            </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "22.2%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('competencyMapping.totalCompetency')} */}
                                                    Position
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position", false)} />
                                            </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "22%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.updatedBy')} */}
                                                    Organization
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("organization", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("organization", false)} />
                                            </Typography> */}
                                            </Box>
                                            <Box sx={{ display: "flex", flexDirection: "row", width: "12.45%" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                    {/* {t('admin.label.createdBy')} */}
                                                    Position Type
                                                </Typography>
                                                {/* <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("position_type", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("position_type", false)} />
                                            </Typography> */}
                                            </Box>
                                        </Box>
                                    }
                                    <Divider width="100%" />
                                </Box>
                                {showLoading ?
                                    <Box sx={{ paddingTop: "87px", display: "flex", alignItems: "center", flexDirection: "column", paddingBottom: "87px" }}>
                                        <Box sx={{ position: 'relative', width: "70px" }}>
                                            <CircularProgress
                                                variant="determinate"
                                                sx={{
                                                    color: "#AAAAAA",
                                                }}
                                                size={70}
                                                thickness={4}
                                                value={100}
                                            />
                                            <CircularProgress
                                                variant="indeterminate"
                                                disableShrink
                                                sx={{
                                                    color: '#5DA196',
                                                    animationDuration: '1000ms',
                                                    position: 'absolute',
                                                    left: 0,
                                                    [`& .${circularProgressClasses.circle}`]: {
                                                        strokeLinecap: 'round',
                                                    },
                                                }}
                                                size={70}
                                                thickness={4}
                                            />
                                        </Box>
                                        <Typography color="#AAAAAA" fontWeight="500" fontSize={16} lineHeight="23.92px" pt="30px">
                                            Loading ...
                                        </Typography>
                                    </Box>
                                    :
                                    currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) =>
                                        formik.values.employees.length > 0 ? (
                                            <Box px="40px">
                                                <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                    <Box
                                                        sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                        px="25px"
                                                    >
                                                        <Box sx={{ width: "calc(15.15% - 15px)", display: "flex", alignItems: "center" }} pr="15px">
                                                            <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {`${row?.code}`}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(28.2% - 15px)" }} pr="15px">
                                                            <Typography pb={row?.name?.th !== null && row?.name?.th !== undefined && row?.name?.th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.name?.en !== undefined && row?.name?.en !== null ? Util.formatData(row?.name?.en, "") : Util.formatData(row?.fullname, "")}
                                                            </Typography>
                                                            {row?.name?.th !== null && row?.name?.th !== undefined && row?.name?.th !== "" ?
                                                                <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.name?.th}
                                                                </Typography>
                                                                :
                                                                null
                                                            }
                                                        </Box>
                                                        <Box sx={{ width: "calc(22.2% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.position}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(22% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.organization}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "calc(12.45% - 15px)" }} pr="15px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                {row?.position_type}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: "flex", width: "75px" }} pr="15px">
                                                            <CloseIconLF style={{ cursor: "pointer" }} onClick={e => clearOne(row)} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                        )
                                            :
                                            (
                                                <Box px="40px">
                                                    <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                        <Box
                                                            sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                            px="25px"
                                                        >
                                                            <Box sx={{ width: "15.15%", display: "flex", alignItems: "center" }} pr="15px">
                                                                <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {`${row?.code}`}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "28.2%" }} pr="15px">
                                                                <Typography pb={row?.name?.th !== null && row?.name?.th !== undefined && row?.name?.th !== "" ? "0" : "5px"} fontWeight="500" fontSize={16} lineHeight="26.91px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.name?.en !== undefined && row?.name?.en !== null ? Util.formatData(row?.name?.en, "") : Util.formatData(row?.fullname, "")}
                                                                </Typography>
                                                                {row?.name?.th !== null && row?.name?.th !== undefined && row?.name?.th !== "" ?
                                                                    <Typography fontWeight="400" fontSize={14} lineHeight="20.93px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                        {row?.name?.th}
                                                                    </Typography>
                                                                    :
                                                                    null
                                                                }
                                                            </Box>
                                                            <Box sx={{ width: "22.2%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.position}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "22%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.organization}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: "12.45%" }} pr="15px">
                                                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                    {row?.position_type}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                    <Divider width="100%" />
                                                </Box>
                                            ))
                                        :
                                        <Box sx={{ paddingTop: "87px", textAlign: "center", paddingBottom: "143px" }}>
                                            <Nodata />
                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                No data found
                                            </Typography>
                                        </Box>
                                }
                            </Paper>
                        </div>
                    </Box>
                    <Grid container mt="30px"  >
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={10}>
                                    <Typography style={{ fontWeight: "300" }}>10</Typography>
                                </MenuItem>
                                <MenuItem value={20}>
                                    <Typography style={{ fontWeight: "300" }}>20</Typography>
                                </MenuItem>
                                <MenuItem value={30}>
                                    <Typography style={{ fontWeight: "300" }}>30</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <DialogLaunchForm data={formik.values} oldDataFilter={oldDataFilter} open={openLaunchForm} close={closeLaunchForm} openSuccessAddDialog={e => openSuccessAddDialog(true)} />
            <SimpleDialog
                open={isSuccessAddDialogOpen}
                doDirect={() => handleDirect()}
                setValue={handleDirect}
                text="Form was launched"
                page={true}
            />
        </Box>
    );
};
export default LaunchForm;
